export default "__VITE_ASSET__f7e5a0a5__"